import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Button from "../components/Button";

export default function Video() {
  const { nombre } = useParams();
  const navigate = useNavigate();

  // Construir la ruta del vídeo a partir del nombre recibido por parámetro
  const videoUrl = `/videos/${nombre}.mov`;

  return (
    <div className="p-4 max-w-2xl mx-auto text-center mt-4">
      {/* Botón Volver */}
      <Button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 mb-4 text-gray-700 hover:text-gray-900"
        aria-label="Volver"
      >
        <ArrowLeft size={20} /> Volver
      </Button>

      <h2 className="text-2xl font-bold mb-4">Vídeo</h2>

      {/* Reproductor de vídeo */}
      <video
        src={videoUrl}
        controls
        className="w-full rounded shadow-md"
        preload="metadata"
      >
        Tu navegador no soporta la etiqueta de vídeo.
      </video>
    </div>
  );
}